import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Users, Trophy, Calendar, Heart } from 'lucide-react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import ContactModal from '../components/ContactModal';

const JuniorsPage = () => {
  const [isContactModalOpen, setIsContactModalOpen] = useState(false);

  return (
    <div className="min-h-screen bg-white">
      <Header scrollY={100} />
      
      <div className="pt-24 pb-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <Link to="/" className="inline-flex items-center text-green-600 hover:text-green-700 mb-8 transition-colors">
            <ArrowLeft className="w-5 h-5 mr-2" />
            Retour à l'accueil
          </Link>
          
          <div className="mb-12">
            <h1 className="text-5xl font-bold text-gray-900 mb-4">
              Cours de tennis juniors
            </h1>
            <p className="text-xl text-gray-600">
              Développez la passion du tennis chez les jeunes
            </p>
          </div>

          {/* Image des juniors jouant au tennis - joyeuse et dynamique */}
          <div className="mb-12 rounded-2xl overflow-hidden shadow-xl">
            <img 
              src="https://customer-assets.emergentagent.com/job_clubtennis-update/artifacts/pmmkw10h_juniors.png"
              alt="Cours juniors TC Cheyres-Châbles"
              className="w-full h-96 object-cover"
            />
          </div>

          {/* Information sur les cours */}
          <div className="bg-gradient-to-br from-blue-50 to-cyan-50 border-l-4 border-blue-500 p-8 rounded-xl mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-6">Informations sur les cours</h2>
            
            <div className="space-y-4">
              <div className="bg-white p-6 rounded-lg shadow-sm border-l-4 border-green-500">
                <div className="flex items-center gap-2 mb-3">
                  <h3 className="text-xl font-bold text-gray-900">📅 Cours d'hiver 2026-2027</h3>
                  <span className="bg-green-500 text-white text-xs font-bold uppercase tracking-wider px-2.5 py-1 rounded-full">Inscriptions ouvertes</span>
                </div>
                <p className="text-gray-700 mb-4">
                  Les inscriptions pour les cours d'hiver <strong>2026-2027</strong> sont ouvertes !
                  Réservez votre place dès maintenant en remplissant le formulaire en ligne.
                </p>
                <a
                  href="https://docs.google.com/forms/d/e/1FAIpQLSfY1hAn2p57pYgjWQlg8-ufBvfRRYZsALaU5er2EPz3P4DOaQ/viewform?usp=dialog"
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="winter-courses-register-button"
                  className="inline-flex items-center gap-2 bg-green-600 hover:bg-green-700 text-white font-bold px-6 py-3 rounded-full transition-all hover:scale-105 shadow-md"
                >
                  S'inscrire aux cours d'hiver
                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M14 5l7 7m0 0l-7 7m7-7H3" />
                  </svg>
                </a>
              </div>

              <div className="bg-white p-6 rounded-lg shadow-sm border-l-4 border-red-500">
                <div className="flex items-center gap-2 mb-3">
                  <h3 className="text-xl font-bold text-gray-900">☀️ Cours d'été 2026</h3>
                  <span className="bg-red-500 text-white text-xs font-bold uppercase tracking-wider px-2.5 py-1 rounded-full">Complets</span>
                </div>
                <p className="text-gray-700">
                  Les cours d'été 2026 sont <strong>complets</strong> — les inscriptions ne sont plus possibles.
                </p>
              </div>
            </div>

            <p className="text-gray-600 mt-6 text-center">
              Pour toute question, n'hésitez pas à nous contacter via le formulaire de contact.
            </p>
          </div>

          {/* Nouveaux entraîneurs 2025 */}
          <div className="bg-gradient-to-br from-green-50 to-emerald-50 p-6 rounded-2xl mb-12">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">Deux nouveaux entraîneurs pour 2025</h2>
            
            <div className="prose max-w-none text-gray-700 leading-relaxed space-y-3 text-sm">
              <p>
                Le comité a décidé de donner une nouvelle dynamique au mouvement junior en 
                concluant un partenariat avec <strong>STM Club</strong>, fondé par <strong>Fabrice Sbarro</strong>, 
                coach international sur le circuit ATP/WTA/ITF et <strong>Patrick Thomet</strong>, ancien joueur R1 et 
                entraineur Swisstennis A.
              </p>
              
              <p>
                Nous aurons donc la chance d'accueillir deux nouveaux coaches formés à la méthode STM 
                pour accompagner nos juniors dès le printemps 2025. Nous souhaitons la bienvenue à{' '}
                <strong>Kaël Piguet</strong> et <strong>Kilian Zurita</strong> !
              </p>
              
              
              <div className="mt-6">
                <a 
                  href="https://www.stmclubs.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center text-green-600 hover:text-green-700 font-semibold"
                >
                  🔗 https://www.stmclubs.com
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <ContactModal 
        isOpen={isContactModalOpen} 
        onClose={() => setIsContactModalOpen(false)} 
      />

      <Footer />
    </div>
  );
};

export default JuniorsPage;